module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "single-message",
    class: 'level_' + _vm.level
  }, [_c('div', {
    staticClass: "message"
  }, [_c('div', {
    class: {
      'admin-header': (_vm.comment.comment && (_vm.comment.user.profilesId === 1 || _vm.comment.user.profilesId === 3))
    }
  }, [_c('span', {
    staticClass: "message-name-user"
  }, [_vm._v(_vm._s(_vm.comment.user.name))]), _vm._v(" "), _c('span', {
    staticClass: "message-date"
  }, [_vm._v(_vm._s(_vm.date(_vm.comment.created)))]), _vm._v(" "), _c('span', {
    staticClass: "message-time"
  }), _vm._v(" "), (_vm.editable && _vm.comment.comment) ? _c('span', {
    staticClass: "remove-button",
    on: {
      "click": _vm.remove
    }
  }, [_c('i', {
    staticClass: "ti-trash"
  })]) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('span', {
    staticClass: "remove-button",
    on: {
      "click": _vm.pin
    }
  }, [_c('i', {
    staticClass: "ti-pin"
  })]) : _vm._e(), _vm._v(" "), (_vm.editable && _vm.comment.comment) ? _c('span', {
    staticClass: "remove-button",
    on: {
      "click": _vm.toggleEditor
    }
  }, [_c('i', {
    staticClass: "ti-pencil"
  })]) : _vm._e()]), _vm._v(" "), (!_vm.showEditor) ? _c('p', {
    staticClass: "message-text",
    domProps: {
      "innerHTML": _vm._s(_vm.comment.comment)
    }
  }) : _c('p', {
    staticClass: "message-text"
  }, [_c('Editor', {
    attrs: {
      "placeholder": "Оставьте комментарий",
      "content": _vm.comment.comment
    },
    on: {
      "change": _vm.setComment,
      "ready": _vm.setComment,
      "ctrl-enter": function($event) {
        !_vm.hasErrorComment(_vm.commentText) && _vm.updateComment()
      }
    }
  })], 1), (_vm.showEditor) ? _c('div', {
    staticStyle: {
      "height": "1em",
      "margin": "1em 0"
    }
  }, [(_vm.hasSmallComment(_vm.commentText)) ? _c('span', [_c('em', [_vm._v("Сообщение должно быть как минимум 20 символов.")])]) : _vm._e(), _vm._v(" "), (_vm.hasNormalComment(_vm.commentText)) ? _c('span', [_c('em', [_vm._v("Длина сообщения " + _vm._s(_vm.commentText.length) + " из 4096 символов.")])]) : _vm._e(), _vm._v(" "), (_vm.hasLargeComment(_vm.commentText)) ? _c('span', {
    staticClass: "error"
  }, [_c('em', [_vm._v("Слишком длинное сообщение. " + _vm._s(_vm.commentText.length) + " из 4096 символов.")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showEditor) ? _c('button', {
    staticClass: "reviews-button save-comment-button",
    attrs: {
      "disabled": _vm.hasErrorComment(_vm.commentText)
    },
    on: {
      "click": _vm.updateComment
    }
  }, [_vm._v("\n                Сохранить\n            ")]) : _vm._e(), _vm._v(" "), _c('p'), _vm._v(" "), (!_vm.comment.comment) ? _c('p', {
    staticStyle: {
      "color": "gray"
    }
  }, [_c('em', [_vm._v("Комментарий удален")])]) : _vm._e(), _vm._v(" "), (_vm.isLogged) ? _c('button', {
    staticClass: "message-button",
    on: {
      "click": function($event) {
        _vm.showReply = !_vm.showReply
      }
    }
  }, [_vm._v("\n            Ответить\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showReply),
      expression: "showReply"
    }],
    attrs: {
      "id": "replyForm"
    }
  }, [_c('Editor', {
    attrs: {
      "placeholder": "Оставьте комментарий",
      "content": _vm.replyCommentHtml
    },
    on: {
      "change": _vm.setReplyComment,
      "ctrl-enter": function($event) {
        !_vm.hasErrorComment(_vm.replyCommentText) && _vm.saveReply
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "small",
    staticStyle: {
      "height": "1em",
      "margin": "1em 0"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasSmallComment(_vm.replyCommentText)),
      expression: "hasSmallComment(replyCommentText)"
    }]
  }, [_c('em', [_vm._v("Сообщение должно быть как минимум 20 символов.")])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasNormalComment(_vm.replyCommentText)),
      expression: "hasNormalComment(replyCommentText)"
    }]
  }, [_c('em', [_vm._v("Длина сообщения " + _vm._s(_vm.replyCommentText.length) + " из 4096 символов.")])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasLargeComment(_vm.replyCommentText)),
      expression: "hasLargeComment(replyCommentText)"
    }],
    staticClass: "error"
  }, [_c('em', [_vm._v("Слишком длинное сообщение. " + _vm._s(_vm.replyCommentText.length) + " из 4096 символов.")])])]), _vm._v(" "), _c('button', {
    staticClass: "reviews-button small",
    attrs: {
      "disabled": _vm.hasErrorComment(_vm.replyCommentText)
    },
    on: {
      "click": _vm.saveReply
    }
  }, [_vm._v("\n            Отправить\n        ")])], 1), _vm._v(" "), _vm._l((_vm.allComments[_vm.comment.id]), function(child) {
    return (_vm.allComments[_vm.comment.id]) ? _c('div', [_c('Comment', {
      attrs: {
        "comment": child,
        "level": _vm.level + 1
      }
    })], 1) : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b4efed0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Comment.vue
// module id = 116
// module chunks = 0